var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "cb-integrations" } }, [
    _c(
      "div",
      { staticClass: "ml-3 mt-3" },
      [
        _c("div", { staticClass: "big-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.allIntegrations"))),
        ]),
        _vm._v(" "),
        _vm.integrationPage === "webhook"
          ? _c("WebHook")
          : _c("div", { staticClass: "stories" }, [
              _c(
                "div",
                {
                  staticClass: "story",
                  on: {
                    click: function ($event) {
                      _vm.SelectStoryIntegrationWithSupsisWebModalVisible = true
                    },
                  },
                },
                [
                  _vm.isChatWidgetInstalled()
                    ? _c("div", { staticClass: "status" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" done "),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("chatbotv2.installationOK")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("SelectStoryIntegrationWithSupsisWeb", {
                    attrs: {
                      "modal-visible":
                        _vm.SelectStoryIntegrationWithSupsisWebModalVisible,
                    },
                    on: {
                      "modal-visible": function ($event) {
                        _vm.SelectStoryIntegrationWithSupsisWebModalVisible = false
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "img supsis" },
                    [_c("SupsisIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.chatWidget"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.integrateYourCBwithChatWidget"))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "story", on: { click: _vm.gotoWebhook } },
                [
                  _c(
                    "div",
                    { staticClass: "img webhooks" },
                    [_c("WebhookIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.webhooks"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.integrateYourCBwithWebHook"))
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story",
                  on: { click: _vm.showWhatsappIntegration },
                },
                [
                  _vm.isChatWidgetIntegratedWithWhatsapp()
                    ? _c("div", { staticClass: "status" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" done "),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("chatbotv2.installationOK")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "img whatsapp" },
                    [_c("WhatsappIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.whatsapp"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("chatbotv2.integratePlatform", {
                            integratable: "Whatsapp",
                          })
                        ) +
                        "\n                    " +
                        _vm._s(
                          _vm.$t("chatbotv2.planRequired", {
                            integratable: "Whatsapp Plus",
                          })
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("WhatsappIntegrationsModal", {
                    attrs: {
                      title: _vm.$t("chatbotv2.whatsappIntegrationTitle"),
                      channels: _vm.whatsappWebChannels,
                      modalVisable: _vm.whatsappIntegrationModalVisible,
                    },
                    on: {
                      close: function ($event) {
                        _vm.whatsappIntegrationModalVisible = false
                      },
                      submit: function ($event) {
                        _vm.whatsappIntegrationModalVisible = false
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story",
                  on: { click: _vm.showTrendyolIntegration },
                },
                [
                  _vm.isChatWidgetIntegratedWithTrendyol()
                    ? _c("div", { staticClass: "status" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" done "),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("chatbotv2.installationOK")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "img trendyol" },
                    [_c("TrendyolIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.trendyol"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("chatbotv2.integratePlatform", {
                            integratable: "Trendyol",
                          })
                        ) +
                        "\n                    " +
                        _vm._s(
                          _vm.$t("chatbotv2.planRequired", {
                            integratable: "Trendyol",
                          })
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("TrendyolIntegrationsModal", {
                    attrs: {
                      title: _vm.$t("chatbotv2.trendyolIntegration"),
                      channels: [],
                      modalVisable: _vm.trendyolIntegrationModalVisible,
                    },
                    on: {
                      close: function ($event) {
                        _vm.trendyolIntegrationModalVisible = false
                      },
                      submit: function ($event) {
                        _vm.trendyolIntegrationModalVisible = false
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story",
                  on: { click: _vm.showWhatsappIntergationBusinessAPI },
                },
                [
                  _vm.isChatWidgetIntegratedWithWhatsappBusinessAPI()
                    ? _c("div", { staticClass: "status" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" done "),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("chatbotv2.installationOK")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "img whatsapp" },
                    [_c("WhatsappIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.whatsappBusinessApi"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbotv2.integratePlatform", {
                          integratable: "Whatsapp Business API",
                        })
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("WhatsappIntegrationsModal", {
                    attrs: {
                      title: _vm.$t("chatbotv2.whatsappApiIntegrationTitle"),
                      channels: _vm.whatsappBusinessApiChannels,
                      modalVisable:
                        _vm.whatsappBusinessAPIIntegrationModalVisible,
                    },
                    on: {
                      close: function ($event) {
                        _vm.whatsappBusinessAPIIntegrationModalVisible = false
                      },
                      submit: function ($event) {
                        _vm.whatsappBusinessAPIIntegrationModalVisible = false
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story",
                  on: { click: _vm.showInstagramIntegration },
                },
                [
                  _vm.isChatWidgetIntegratedWithInstagram()
                    ? _c("div", { staticClass: "status" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" done "),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("chatbotv2.installationOK")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("SelectStoryIntegratingWithInstagram", {
                    attrs: {
                      "modal-visible": _vm.integrateInstagramModalVisible,
                    },
                    on: {
                      "modal-visible": function ($event) {
                        _vm.integrateInstagramModalVisible = false
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "img instagram" },
                    [_c("InstagramIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.instagram"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("chatbotv2.integratePlatform", {
                            integratable: "Instagram",
                          })
                        ) +
                        "\n                    " +
                        _vm._s(
                          _vm.$t("chatbotv2.planRequired", {
                            integratable: "Instagram Plus",
                          })
                        ) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story",
                  on: { click: _vm.showTelegramBotIntegration },
                },
                [
                  _vm.isChatWidgetIntegratedWithTelegramBot()
                    ? _c("div", { staticClass: "status" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" done "),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("chatbotv2.installationOK")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("SelectStoryIntegratingWithTelegramBot", {
                    attrs: {
                      "modal-visible": _vm.integrateTelegramBotModalVisible,
                    },
                    on: {
                      "modal-visible": function ($event) {
                        _vm.integrateTelegramBotModalVisible = false
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "img telegram" },
                    [_c("TelegramIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.telegram"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("chatbotv2.integratePlatform", {
                            integratable: "Telegram",
                          })
                        ) +
                        "\n                    " +
                        _vm._s(
                          _vm.$t("chatbotv2.planRequired", {
                            integratable: "Telegram Bot",
                          })
                        ) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story voting",
                  on: { click: function ($event) {} },
                },
                [
                  _c(
                    "div",
                    { staticClass: "img facebook" },
                    [_c("FacebookIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.facebook"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbotv2.integrateYourCBwithIntegratable", {
                          integratable: "Facebook",
                        })
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story voting",
                  on: { click: function ($event) {} },
                },
                [
                  _c(
                    "div",
                    { staticClass: "img twitter" },
                    [_c("TwitterIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.twitter"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbotv2.integrateYourCBwithIntegratable", {
                          integratable: "Twitter",
                        })
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story voting",
                  on: { click: function ($event) {} },
                },
                [
                  _c("div", { staticClass: "img skype" }, [_c("SkypeIcon")], 1),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.skype"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbotv2.integrateYourCBwithIntegratable", {
                          integratable: "Skype",
                        })
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story voting",
                  on: { click: function ($event) {} },
                },
                [
                  _c(
                    "div",
                    { staticClass: "img shopify" },
                    [_c("ShopifyIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.shopify"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbotv2.integrateYourCBwithIntegratable", {
                          integratable: "Shopify",
                        })
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "story voting",
                  on: { click: function ($event) {} },
                },
                [
                  _c("div", { staticClass: "img slack" }, [_c("SlackIcon")], 1),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.slack"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbotv2.integrateYourCBwithIntegratable", {
                          integratable: "Slack",
                        })
                      )
                    ),
                  ]),
                ]
              ),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }